import React, { useEffect, useState } from 'react';
import { API } from '../constant';
import { getToken } from "../helpers";
import { useAuthContext } from "../context/AuthContext";
import Loading from "../Components/Hooks/Loading";

const COUNTRIES = [
    { code: 'US', name: 'United States', flag: '🇺🇸' },
    { code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
    { code: 'CA', name: 'Canada', flag: '🇨🇦' },
    { code: 'AU', name: 'Australia', flag: '🇦🇺' },
    { code: 'DE', name: 'Germany', flag: '🇩🇪' },
    { code: 'FR', name: 'France', flag: '🇫🇷' },
    { code: 'IN', name: 'India', flag: '🇮🇳' },
    { code: 'PK', name: 'Pakistan', flag: '🇵🇰' },
    { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
    { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
    { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
    { code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
    { code: 'IE', name: 'Ireland', flag: '🇮🇪' },
    { code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
    { code: 'SE', name: 'Sweden', flag: '🇸🇪' },
    { code: 'NO', name: 'Norway', flag: '🇳🇴' },
    { code: 'DK', name: 'Denmark', flag: '🇩🇰' },
    { code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
    { code: 'ES', name: 'Spain', flag: '🇪🇸' },
    { code: 'IT', name: 'Italy', flag: '🇮🇹' },
    { code: 'PT', name: 'Portugal', flag: '🇵🇹' },
    { code: 'BE', name: 'Belgium', flag: '🇧🇪' },
    { code: 'AT', name: 'Austria', flag: '🇦🇹' },
    { code: 'PL', name: 'Poland', flag: '🇵🇱' },
    { code: 'BR', name: 'Brazil', flag: '🇧🇷' },
    { code: 'MX', name: 'Mexico', flag: '🇲🇽' },
    { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
    { code: 'ZA', name: 'South Africa', flag: '🇿🇦' },
    { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
    { code: 'JP', name: 'Japan', flag: '🇯🇵' },
    { code: 'CN', name: 'China', flag: '🇨🇳' },
    { code: 'KR', name: 'South Korea', flag: '🇰🇷' },
    { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
    { code: 'PH', name: 'Philippines', flag: '🇵🇭' },
    { code: 'BD', name: 'Bangladesh', flag: '🇧🇩' },
    { code: 'EG', name: 'Egypt', flag: '🇪🇬' },
    { code: 'TR', name: 'Turkey', flag: '🇹🇷' },
    { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
    { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
    { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
];

const BillingAdress = () =>{
    const { user, setUser } = useAuthContext();
    const userId = user?.id;
    const [ formActive, setformActive ] = useState("");
    const [loading, setLoading] = useState(false);
    const [address, setAddress] =useState(user?.address || '');
    const [city, setCity] =useState(user?.city || '');
    const [state, setState] =useState(user?.state || '');
    const [postalCode, setPostalCode] =useState(user?.postalCode || '');
    const [country, setCountry] =useState(user?.country || 'US');
    const [message, setMessage] =useState("");
    const [newUser, setNewUser] =useState({});



    const handleEditAddress = async (values) => {
        if (!userId) return;
        setLoading(true);
        const formValues = {};

        const formData = new FormData(values.target);

        formData.forEach((value, key) => formValues[key] = value);

        values.preventDefault();

        // console.log(JSON.stringify(formValues));
        // console.log(user.id);
        try {
          setLoading(true);
          const response = await fetch(`${API}/users/${userId}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              // set the auth token to the user's jwt
              Authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(formValues),
          });
          const responseData = await response.json();
          if (!response.ok) {
            throw new Error(responseData?.error?.message || responseData?.message || 'Failed to update billing address');
          }
    
          setUser(responseData);
          setNewUser(responseData);
          setMessage("Data updated successfully!");
          // console.log("Data saved successfully!");
          setLoading(false);
        } catch (error) {
          console.error(error);
          setMessage(error.message || "Error While Updating the Profile!");
        } finally {
          setLoading(false);
          
        }
      };
      const onchangeHandler =(e)=>{
        if(e.target.name==='address')
            setAddress(e.target.value);
        else if(e.target.name==='city')
            setCity(e.target.value);
        else if(e.target.name==='state')
            setState(e.target.value);
        else if(e.target.name==='postalCode')
            setPostalCode(e.target.value);
        else if(e.target.name==='country')
            setCountry(e.target.value);
      }

      const fUser = async(currentUserId)=>{
        if (!currentUserId) return;
        setLoading(true);
        try{
        const response = await fetch(`${API}/users/${currentUserId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // set the auth token to the user's jwt
            Authorization: `Bearer ${getToken()}`,
          },
        });
        if (!response.ok) {
          const responseData = await response.json();
          throw new Error(responseData?.error?.message || responseData?.message || 'Failed to fetch billing address');
        }
        const newuser = await response.json()
        setNewUser(newuser);
        setLoading(false);
      } catch (error) {
          console.error(error);
          setLoading(false);
        } 
      }
      useEffect(() => {
      if (user) {
        setAddress(user.address || '');
        setCity(user.city || '');
        setState(user.state || '');
        setPostalCode(user.postalCode || '');
        setCountry(user.country || 'US');
      }
      fUser(userId);
      },[userId, user])
    // console.log(newUser);
      
    return(
            <div className="billing-address">
                <div className="billing-address-inner">
                    {newUser.address ? (
                        <div className="address">
                            <span>{newUser.address}, </span>
                            <span>{newUser.city}, </span>
                            <span>{newUser.state}, </span>
                            <span>{newUser.postalCode}, </span>
                            <span>{newUser.country}</span>
                        </div>
                    ) : (
                        <div className="address">No billing address added yet.</div>
                    )}
                    <button onClick={()=>{setformActive('active-form')}} className="theme-btn">
                        {newUser.address ? 'Edit' : 'Add'}
                    </button>
                </div>
                {loading && <Loading />}

                <div className={`theme-form popup ${formActive}`}>
                  <div className="form-wrap">
                  <button onClick={()=>{setformActive('');setMessage('')}} className=" close-btn theme-btn" type="button">X</button>
                  <div className="head-title">Edit Billing Address</div>
                  <form onSubmit={handleEditAddress}>
                      <label className="user">
                          <input onChange={onchangeHandler} className="field-without-icon" type="text" name='address' placeholder="Address line1" value={address} />
                      </label>
                      <label className="email">
                          <input onChange={onchangeHandler} className="field-without-icon" type="text" name='city' placeholder="City" value={city}/>
                      </label >
                      <label className="email">
                          <input onChange={onchangeHandler} className="field-without-icon" type="text" name='state' placeholder="State" value={state}/>
                      </label >
                      <label className="email">
                          <input onChange={onchangeHandler} className="field-without-icon" maxLength="5" type="text" name='postalCode' placeholder="Postal code" value={postalCode}/>
                      </label >
                      <label className="email">
                          <select name='country' value={country} onChange={onchangeHandler} className="field-without-icon" disabled>
                              {COUNTRIES.map(c => (
                                  <option key={c.code} value={c.code}>{c.flag} {c.name}</option>
                              ))}
                          </select>
                      </label >
                     
                      <div className="form-footer"><button className="theme-btn" type="submit">Update</button> </div> 

                      <div className="message success">{message}</div>
                  </form>
                  </div>
              </div>
              
            </div>   
    );
}
export default BillingAdress;
